import { AppDataTable } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useAuthStore } from '@/stores/auth'
import { filterInquiries } from '../../-lib/inquiry-filter'
import { DEFAULT_INQUIRY_SEARCH } from '../../-lib/inquiry-search-parser'
import { Route } from '../../index'
import { columns } from './components/columns'
import { useInquiries } from './hooks/useInquiries'

export function ListArea() {
  const { data, isLoading } = useInquiries()
  const inquiries = data?.inquiries ?? []
  const { search, selectedId } = Route.useSearch()
  const navigate = Route.useNavigate()
  const initialSelectionDone = useRef(false)
  const user = useAuthStore((state) => state.user)
  const currentMemberId = user?.memberId ?? null
  const currentDivisionId = user?.divisionId ?? null
  const filteredInquiries = useMemo(
    () => filterInquiries(inquiries, search ?? '', currentMemberId, currentDivisionId),
    [inquiries, search, currentMemberId, currentDivisionId],
  )

  // 初回遷移時に表示されたレコードの先頭を自動選択
  useEffect(() => {
    if (isLoading) return
    const firstInquiry = filteredInquiries[0]
    if (!selectedId && firstInquiry && !initialSelectionDone.current) {
      initialSelectionDone.current = true
      navigate({ search: (prev: Record<string, unknown>) => ({ ...prev, selectedId: firstInquiry.id }), replace: true })
    }
  }, [isLoading, selectedId, filteredInquiries, navigate])

  const [pageSize, setPageSize] = useState(100)
  const [sortKey, setSortKey] = useState<string | null>(null)
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')

  const handleSortChange = (key: string | null, direction: 'asc' | 'desc') => {
    setSortKey(key)
    setSortDirection(direction)
  }

  return (
    <div className='flex-1 h-full w-full overflow-x-auto'>
      <AppDataTable
        data={filteredInquiries}
        columns={columns}
        isLoading={isLoading}
        pageSize={pageSize}
        onPageSizeChange={setPageSize}
        pageSizeOptions={[100, 200, 300]}
        emptyMessage={search && search !== DEFAULT_INQUIRY_SEARCH ? '検索結果がありませんでした' : 'データがありません'}
        sortKey={sortKey}
        sortDirection={sortDirection}
        onSortChange={handleSortChange}
        columnSelector={{ cookieKey: 'header-select-inquiries' }}
        getRowKey={(row) => row.id}
        onRowClick={(row) =>
          navigate({
            search: (prev: Record<string, unknown>) => ({
              ...prev,
              selectedId: row.id === selectedId ? undefined : row.id,
            }),
          })
        }
        selectedRowKey={selectedId ?? null}
        getRowClassName={(row) => (selectedId === row.id ? 'bg-selected' : undefined)}
      />
    </div>
  )
}
